// extracted by mini-css-extract-plugin
module.exports = {"seasonsForms":"style_seasonsForms__2JokL","usernameInput":"style_usernameInput__29KT2","formContainer":"style_formContainer__2c8il","description":"style_description__vkIfo"};